import { Link } from "react-router-dom";
import { funds } from "../data/funds.js";

export default function FundsGrid({ heading = "Three vehicles. Three jurisdictions.", showHeader = true }) {
  return (
    <section className="funds-section">
      <div className="wrap">
        {showHeader && (
          <div className="funds-head">
            <div>
              <div className="eyebrow">The funds</div>
              <h2 style={{ color: "var(--white)", marginTop: 14 }}>{heading}</h2>
            </div>
            <p className="sub" style={{ maxWidth: "38ch" }}>
              Capital is deployed through a Cayman-domiciled fund, a Luxembourg feeder vehicle,
              and a SEBI-registered Indian AIF.
            </p>
          </div>
        )}

        <div className="fund-grid">
          {funds.map(f => (
            <Link key={f.slug} to={`/funds/${f.slug}`} className="fund">
              <div className="eyebrow">{f.eyebrow}</div>
              <h3>{f.title}</h3>
              <div className="num">
                {f.headline}<span className="sm">{f.headlineSub}</span>
              </div>
              <p>{f.description}</p>
              <div className="footer">
                <span className="tag">{f.tag}</span>
                <span className="right">View →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
